import type { MetricBucket } from "./types";

export function getMetricValue(bucket: MetricBucket | null | undefined, key: string): number | null {
    return bucket?.[key]?.calc ?? null;
}
